<div class="admin-user-activities">
  <div class="activities--container">
        <!-- Tabs: Assets | Compute | User action -->
        <div class="activities__tabs-row">
          <div class="activities__tabs">
            <button
              type="button"
              class="activities__tab"
              [class.activities__tab--active]="activeLogType === 'ASSET'"
              (click)="setLogType('ASSET')"
            >
              Assets
            </button>
            <button
              type="button"
              class="activities__tab"
              [class.activities__tab--active]="activeLogType === 'COMPUTE'"
              (click)="setLogType('COMPUTE')"
            >
              Compute
            </button>
            <button
              type="button"
              class="activities__tab"
              [class.activities__tab--active]="activeLogType === 'USER_ACTION'"
              (click)="setLogType('USER_ACTION')"
            >
              User action
            </button>
          </div>

          <div class="activities__tabs-actions">
            @if (workspace.canViewPlatformSuperset()) {
            <div class="view-toggle">
              <button
                type="button"
                class="view-toggle-btn"
                [class.active]="!showAnalytics"
                (click)="toggleAnalyticsView(false)"
                aria-label="Table View"
                title="Table View"
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <rect x="3" y="4" width="18" height="16" rx="2" stroke="currentColor" stroke-width="2"></rect>
                  <line x1="3" y1="10" x2="21" y2="10" stroke="currentColor" stroke-width="2"></line>
                  <line x1="9" y1="10" x2="9" y2="20" stroke="currentColor" stroke-width="2"></line>
                  <line x1="15" y1="10" x2="15" y2="20" stroke="currentColor" stroke-width="2"></line>
                </svg>
              </button>
              <button
                type="button"
                class="view-toggle-btn"
                [class.active]="showAnalytics"
                (click)="toggleAnalyticsView(true)"
                aria-label="Superset View"
                title="Superset View"
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path d="M4 19L10 13L14 17L20 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  <path d="M20 11V7H16" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
              </button>
            </div>
            }

            <button
              *ngIf="!showAnalytics"
              type="button"
              class="toolbar-export-btn"
              aria-label="Export table"
              (click)="onExport()"
            >
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                aria-hidden="true"
              >
                <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                <polyline points="15 3 21 3 21 9" />
                <line x1="10" y1="14" x2="21" y2="3" />
              </svg>
              <span>Export</span>
            </button>
          </div>
        </div>

        <div class="analytics-panel" *ngIf="showAnalytics">
          <div class="analytics-panel--body">
            <div class="analytics-panel--loading" *ngIf="analyticsLoading">
              <div class="analytics-panel--spinner"></div>
              <span>Loading dashboard...</span>
            </div>

            <div class="analytics-panel--error" *ngIf="analyticsError && !analyticsLoading">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
                <line x1="12" y1="8" x2="12" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                <circle cx="12" cy="16" r="1" fill="currentColor"/>
              </svg>
              {{ analyticsError }}
            </div>

            <div
              #analyticsMount
              class="analytics-panel--mount"
              [class.hidden]="analyticsLoading || !!analyticsError"
            ></div>
          </div>
        </div>

        <ng-container *ngIf="!showAnalytics">
        <!-- Filter Section -->
        <app-filter-panel
          [fields]="effectiveFilterFields"
          [defaultExpanded]="false"
          (filterChange)="onFilterChange($event)"
          (clearFilters)="onClearFilters()"
        ></app-filter-panel>

        <!-- Table -->
        <app-table
          [columns]="columns"
          [data]="activitiesData"
          [dropdownOpenRowIndex]="openDropdownRowIndex"
          [scrollHeight]="'400px'"
          [loading]="loading"
          [pagination]="pagination"
          [emptyMessage]="emptyMessage"
          [striped]="true"
          [bordered]="true"
          [hoverable]="true"
          [showExportButton]="false"
          (export)="onExport()"
          (pageChange)="onPageChange($event)"
          (pageSizeChange)="onPageSizeChange($event)"
          (sortChange)="onSortChange($event)"
        >
          <!-- Custom Activity Column with Left Border Accent -->
          <ng-template #activityCell let-row>
            <div class="activity-cell" [ngClass]="getActivityClass(row.activity)">
              <span class="activity-text">{{ row.activity }}</span>
            </div>
          </ng-template>
          
          <!-- Custom Action Column (dropdown is rendered in fixed overlay below) -->
          <ng-template #actionCell let-row>
            <div class="action-cell-wrapper">
              <button 
                class="action-btn" 
                appActionDropdownTrigger
                (click)="toggleActionDropdown($event, row)"
                [class.active]="isDropdownOpen(row)"
              >
                <span>Action</span>
              </button>
            </div>
          </ng-template>
        </app-table>
        </ng-container>
      </div>
</div>

<!-- Fixed overlay: dropdown on top of table (outside scroll container) -->
<div
  *ngIf="dropdownPosition && openDropdownRow"
  class="action-dropdown-overlay"
  [style.top.px]="dropdownPosition.top"
  [style.left.px]="dropdownPosition.left"
  [style.right.px]="dropdownPosition.right"
  (click)="$event.stopPropagation()"
>
  <ul class="dropdown-list">
    <li class="dropdown-item">
      <button type="button" class="dropdown-link" (click)="handleAction('view', openDropdownRow)">
        Details
      </button>
    </li>
  </ul>
</div>

<!-- Activity Details Modal -->
<app-tab-modal
  [(visible)]="isModalVisible"
  header="Activity Details"
  [width]="'600px'"
  [height]="'520px'"
  [tabs]="modalTabs"
  defaultTab="activityInfo"
  (onClose)="closeModal()"
></app-tab-modal>

<!-- User Information Tab Content Template -->
<ng-template #userInfoTabContent>
  <div class="user-details-section" *ngIf="selectedActivity">
    <div *ngIf="!userDetails && !showAssetCreatedAtInModal()" class="no-data-message">
      No Data Available
    </div>
    <div *ngIf="!userDetails && showAssetCreatedAtInModal()" class="no-data-message">
      No user profile available
    </div>
    <div *ngIf="userDetails">
      <div class="detail-row">
        <div class="detail-label">Name:</div>
        <div class="detail-value">{{ userDetails.name || 'N/A' }}</div>
      </div>
      <div class="detail-row">
        <div class="detail-label">Email:</div>
        <div class="detail-value">{{ userDetails.email || 'N/A' }}</div>
      </div>
      <div class="detail-row">
        <div class="detail-label">Roles:</div>
        <div class="detail-value">
          <ng-container *ngIf="formatService.getHighestRole(userDetails.roles || []) as highestRole; else noRole">
            <span class="roles-container">
              <span class="role-badge">{{ highestRole }}</span>
            </span>
          </ng-container>
          <ng-template #noRole><span>N/A</span></ng-template>
        </div>
      </div>
      <div class="detail-row">
        <div class="detail-label">Email Verified:</div>
        <div class="detail-value">{{ userDetails.emailVerified ? 'Yes' : 'No' }}</div>
      </div>
      <div class="detail-row">
        <div class="detail-label">Account Enabled:</div>
        <div class="detail-value">{{ userDetails.account_enabled ? 'Yes' : 'No' }}</div>
      </div>
      <div class="detail-row" *ngIf="!showAssetCreatedAtInModal() && userDetails.createdAt">
        <div class="detail-label">Account Created At:</div>
        <div class="detail-value">
          <span class="date-part">{{ formatService.formatDateOnly(userDetails.createdAt) }}</span>
          <span class="time-part">{{ formatService.formatTimeOnly(userDetails.createdAt) }}</span>
        </div>
      </div>
    </div>
    <div class="detail-row" *ngIf="showAssetCreatedAtInModal()">
      <div class="detail-label">Created At:</div>
      <div class="detail-value" *ngIf="assetCreatedAtLoading">Loading…</div>
      <div class="detail-value" *ngIf="!assetCreatedAtLoading && assetCreatedAtIso">
        <span class="date-part">{{ formatService.formatDateOnly(assetCreatedAtIso) }}</span>
        <span class="time-part">{{ formatService.formatTimeOnly(assetCreatedAtIso) }}</span>
      </div>
      <div class="detail-value" *ngIf="!assetCreatedAtLoading && !assetCreatedAtIso">N/A</div>
    </div>
  </div>
</ng-template>

<!-- Activity Information Tab Content Template -->
<ng-template #activityInfoTabContent>
  <div class="activity-details-section" *ngIf="selectedActivity">
    <div class="detail-row">
      <div class="detail-label">Asset Name:</div>
      <div class="detail-value">{{ selectedActivity.assetName || 'N/A' }}</div>
    </div>
    <div class="detail-row">
      <div class="detail-label">Asset Type:</div>
      <div class="detail-value">{{ formatService.formatAssetType(selectedActivity.assetType) || 'N/A' }}</div>
    </div>
    <div class="detail-row">
      <div class="detail-label">Activity:</div>
      <div class="detail-value">{{ selectedActivity.activity || 'N/A' }}</div>
    </div>
    <div class="detail-row">
      <div class="detail-label">Accessed At:</div>
      <div class="detail-value" *ngIf="selectedActivity.accessedAtIso || selectedActivity.accessedAt">
        <span class="date-part">{{ formatService.formatDateOnly(selectedActivity.accessedAtIso || selectedActivity.accessedAt) }}</span>
        <span class="time-part">{{ formatService.formatTimeOnly(selectedActivity.accessedAtIso || selectedActivity.accessedAt) }}</span>
      </div>
      <div class="detail-value" *ngIf="!selectedActivity.accessedAtIso && !selectedActivity.accessedAt">N/A</div>
    </div>
  </div>
</ng-template>
